// services/auditLogService.js
import api from './api';

export const getAllAuditLogs = async () => {
    try {
        const response = await api.get('/audit-logs/');
        return response.data.results;
    } catch (error) {
        console.error("Error fetching audit logs:", error);
        throw error;
    }
};

export const getAuditLogDetails = async (id, schemaName = null) => {
    try {
        const response = await api.get(`/audit-logs/${id}/`, {
            params: schemaName ? { client: schemaName } : {},
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching audit log details for id ${id}:`, error);
        throw error;
    }
};

export const getAuditLogsWithPagination = async ({
    page = 1,
    pageSize = 10,
    search = "",
    startDate = "",
    endDate = "",
    ordering = "-added_on",
    schemaName = null,
}) => {
    try {
        const params = new URLSearchParams({
            page,
            page_size: pageSize,
            search,
            ordering,
        });
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        if (schemaName) params.append("client", schemaName);

        const response = await api.get('/audit-logs/', { params });
        return {
            results: response.data.results,
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
        };
    } catch (error) {
        console.error("Error fetching audit logs with pagination:", error);
        throw error;
    }
};

export const createAuditLog = async (logData) => {
    try {
        const response = await api.post('/audit-logs/', logData);
        return response.data;
    } catch (error) {
        console.error("Error creating audit log:", error);
        throw error;
    }
};

export const updateAuditLog = async (id, logData) => {
    try {
        const response = await api.put(`/audit-logs/${id}/`, logData);
        return response.data;
    } catch (error) {
        console.error(`Error updating audit log with id ${id}:`, error);
        throw error;
    }
};

export const deleteAuditLog = async (id) => {
    try {
        await api.delete(`/audit-logs/${id}/`);
    } catch (error) {
        console.error(`Error deleting audit log with id ${id}:`, error);
        throw error;
    }
};